import { Outlet } from 'react-router'
import Header from './elements/Header/Header'
import InfoMenu from './elements/InfoMenu'
import NavMenu from './elements/NavMenu/NavMenu'

function Layout() {
	return (
		<div>
			<Header />

			<div className='w-full mt-[35px] lg:mt-[45px] xl:mt-0 max-w-[1440px] mx-auto relative'>
				<InfoMenu
					isOpen={true}
					animate={false}
					className='xl:flex fixed w-full h-full md:w-[315px] bg-white dark:bg-dark-300 z-10 hidden flex-col justify-center drop-shadow-2xl'
				/>
				<div className='w-full container relative top-[15px] xl:top-0 xl:right-[-108px]'>
					<div className='xl:px-[20px]'>
						<Outlet />
					</div>
				</div>
				<div className='absolute w-[108px] right-0 top-0 h-full'>
					<NavMenu
						isOpen={true}
						animate={false}
						className='fixed top-0 w-[108px] h-full bg-white dark:bg-dark-300 z-10 drop-shadow-2xl hidden xl:block'
					/>
				</div>
			</div>
		</div>
	)
}

export default Layout
